/**
 *  @class
 *  @function PredictiveSearch
 */
class PredictiveSearch {
  constructor() {
    this.container = document.getElementById('Search-Drawer');
    this.form = this.container.querySelector('.search-drawer--searchform');
    this.button = document.querySelectorAll('.thb-quick-search');
    this.input = this.container.querySelector('input[type="search"]');
    this.predictiveSearchResultsWrapper = this.container.querySelector('.search-drawer--inner');
    this.predictiveSearchResults = this.predictiveSearchResultsWrapper.querySelector('.thb-predictive-search');

    this.setupEventListeners();
  }

  setupEventListeners() {
    document.addEventListener('search:close', () => this.closeDrawer());
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));
    const clearButton = this.form.querySelector('.search-drawer--clear');
    if (clearButton) {
      const updateClearButton = () => { clearButton.hidden = this.input.value.length === 0; };
      this.input.addEventListener('input', updateClearButton);
      clearButton.addEventListener('click', () => {
        this.input.value = '';
        this.input.focus({ preventScroll: true });
        this.input.dispatchEvent(new Event('input', { bubbles: true }));
        this.close();
      });
      updateClearButton();
    }

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.button.forEach((item, i) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        if (document.body.classList.contains('open-search')) {
          document.body.classList.remove('open-search', 'open-cc');
          this.closeDrawer();
        } else {
          this.opener = item;
          this.container.inert = false;
          document.body.classList.add('open-search', 'open-cc');
          this.focusTimer = setTimeout(() => {
            if (!this.container.inert) this.input.focus({ preventScroll: true });
          }, 100);
          dispatchCustomEvent('search:open');
        }

        return false;
      });
    });
  }

  closeDrawer() {
    clearTimeout(this.focusTimer);
    this.opener?.focus({ preventScroll: true });
    this.container.inert = true;
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.container.classList.remove('active');
      return;
    }
    this.container.classList.add('active');
    if (this.predictiveSearchResults) this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    }
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      return;
    }

    if (this.predictiveSearchResults) this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();

    this.predictiveSearchResults.classList.add('loading');

    fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,collection,article,query&${encodeURIComponent('resources[limit]')}=6&section_id=predictive-search`)
      .then((response) => {
        this.predictiveSearchResults.classList.remove('loading');
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        throw error;
      });
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    let _this = this,
      submitButton = this.container.querySelector('#search-results-submit');

    if (document.body.classList.contains('animations-true')) {
      gsap.to(this.predictiveSearchResults.querySelectorAll('.product-card .product-featured-image-link'), { scale: 1, opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
    }
    submitButton.addEventListener('click', () => {
      _this.form.submit();
    });
  }

  close() {
    this.container.classList.remove('active');
  }
}
window.addEventListener('load', () => {
  if (typeof PredictiveSearch !== 'undefined') {
    new PredictiveSearch();
  }
});
